<template>
  <v-card class="mx-auto"  max-width="90%">
    <v-card-text>
      <v-form ref="store_form" @submit.prevent="saveChanges">
        <v-text-field label="店名" v-model="sport_store.store_name" :rules="[required]" clearable></v-text-field>
        <v-text-field label="住所（郵便番号）" v-model="sport_store.address_postal_code" :rules="[required]" clearable @change="cangePostalCode($event)"></v-text-field>
        <v-text-field label="住所（都道府県）" v-model="sport_store.address_prefecture" :rules="[required]" clearable></v-text-field>
        <v-text-field label="住所（市町村）" v-model="sport_store.address_city_town_village" :rules="[required]" clearable></v-text-field>
        <v-text-field label="住所（番地）" v-model="sport_store.address_street_number" :rules="[required]" clearable></v-text-field>
        <v-text-field label="住所（建物）" v-model="sport_store.address_building_name" ></v-text-field>
        <v-text-field label="電話番号" v-model="sport_store.phone_number" :rules="[required]" clearable></v-text-field>
        <v-text-field label="アクセス" v-model="sport_store.access" ></v-text-field>
        <v-checkbox label="駐車場有り無し" v-model="sport_store.parking_lot_availability"></v-checkbox>
        <v-text-field label="定休日" v-model="sport_store.regular_holiday" ></v-text-field>
        <v-text-field label="営業時間" v-model="sport_store.business_hours" ></v-text-field>
        <v-text-field label="地図" v-model="sport_store.map_url" ></v-text-field>
        <v-text-field label="アピール" v-model="sport_store.appeal_point" ></v-text-field>
        <v-carousel cycle height="300" hide-delimiter-background show-arrows-on-hover>
          <v-carousel-item v-for="(file, index) in uploadFileList" :key="index">
            <v-sheet height="100%" >
              <v-row class="fill-height" align="center" justify="center">
                <v-img :src="file.url"></v-img>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <v-table>
          <tbody>
            <tr v-for="(file, index) in uploadFileList" :key="index">
              <td><v-icon icon="mdi-camera"></v-icon></td>
              <td class="text-left">{{ file.name }}</td>
              <td class="text-right">
                <v-icon @click="deleteImage(index)">mdi-delete</v-icon>
              </td>
            </tr>
          </tbody>
        </v-table>
        <v-file-input
            accept="image/png, image/jpeg, image/bmp"
            prepend-icon="mdi-camera"
            label="写真追加"
            @change="inputImageFile($event)"
            v-model="uploadFileImage"
        ></v-file-input>
        <v-select
          v-model="selectSportsGearValues"
          :items="masterSportList"
          item-title="sport_name"
          item-value="sport_id"
          chips
          label="取扱競技商品"
          multiple
        ></v-select>
        <v-table max-width="100%">
          <tbody>
            <tr v-for="(link, index) in linkList" :key="index">
              <td >
                <v-select
                  v-model="link.category"
                  label="カテゴリ"
                  :items="linkMaster"
                  item-title="name"
                  item-value="master_id"
                  variant="solo"
                  :rules="[required]"
                  clearable >
                </v-select>
              </td>
              <td ><v-text-field label="Path" type="text" v-model="link.path"/></td>
              <td class="text-right">
                <v-icon @click="deleteLink(index)">mdi-delete</v-icon>
              </td>
            </tr>
          </tbody>
        </v-table>
        <v-row class="justify-space-between">
          <v-col></v-col>
          <v-col class="text-right">
            <v-btn icon color="primary" @click="linkAddRow()"><v-icon>mdi-plus</v-icon></v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-alert
              v-if="saveflag"
              type="success"
              title="保存完了"
            ></v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn type="submit" color="primary">Save Changes</v-btn>
          </v-col>
        </v-row>
      </v-form>

    </v-card-text>
  </v-card>

</template>

<script>
  import axios from 'axios'

  export default {
    props: ['sportsStoreId'],
    data: () => ({
      // お店Json
      sport_store: {
        "access": null,
        "address_building_name": null,
        "address_city_town_village": null,
        "address_postal_code": null,
        "address_prefecture": null,
        "address_street_number": null,
        "appeal_point": null,
        "business_hours": null,
        "created_date": null,
        "created_user_id": null,
        "last_updated_date": null,
        "map_url": null,
        "parking_lot_availability": true,
        "phone_number": null,
        "regular_holiday": null,
        "sports_store_id": null,
        "sports_store_inquiry": [],
        "sports_store_link": [],
        "sports_store_photo": [],
        "sports_store_sports_gear": [],
        "store_name": null,
        "updated_user_id": null
      },
      // 編集競技
      selectSportsGearValues: [],
      // 編集写真リスト
      uploadFileList: [],
      // 編集リンクリスト
      linkList: [{category: null, path: null}],
      // 競技マスタ
      masterSportList: [],
      // リンクマスタ
      linkMaster: [],
      // 追加イメージ
      uploadFileImage: null,
      // 保存フラグ
      saveflag: false,
    }),
    created: function () {
      console.log(this.sportsStoreId)
      if (this.sportsStoreId != null) {
        this.getData(this.sportsStoreId)
      } else if (this.$route.params.sportsStoreId != null) {
        this.getData(this.$route.params.sportsStoreId)
      }
      // 競技リスト取得
      axios.get(process.env.VUE_APP_API_URL + '/api/master_sport_list')
        .then(response => {
          console.log(response.data); // mockData
          console.log(response.status); // 200
          this.masterSportList = response.data.master_sport_list
      })
      // リンクマスタ取得
      axios.get(process.env.VUE_APP_API_URL + '/api/master/LINK')
        .then(response => {
          console.log(response.data); // mockData
          console.log(response.status); // 200
          this.linkMaster = response.data.master
      })
    },
    methods: {
      getData(sportsStoreId) {
        this.clrData()
        axios.get(process.env.VUE_APP_API_URL + '/sportsstore/get/' + sportsStoreId)
          .then(response => {
            console.log(response.data); // mockData
            console.log(response.status); // 200
            this.sport_store = response.data.sport_store
            // 写真リスト
            this.sport_store.sports_store_photo.forEach( photo => {
              const fileData = {
                  record_id: photo.record_id,
                  name: photo.filename,
                  url: photo.path
                }
                this.uploadFileList.push(fileData)
            })
            this.sport_store.sports_store_sports_gear.forEach( gear => {
              // 選択済み競技リスト
              this.selectSportsGearValues.push(gear.sport_id)
            })
            this.sport_store.sports_store_link.forEach( link => {
              this.linkList.push(link)
            })
        })
      },
      clrData() {
        this.sport_store = {
          "access": null,
          "address_building_name": null,
          "address_city_town_village": null,
          "address_postal_code": null,
          "address_prefecture": null,
          "address_street_number": null,
          "appeal_point": null,
          "business_hours": null,
          "created_date": null,
          "created_user_id": null,
          "last_updated_date": null,
          "map_url": null,
          "parking_lot_availability": true,
          "phone_number": null,
          "regular_holiday": null,
          "sports_store_id": null,
          "sports_store_inquiry": [],
          "sports_store_link": [],
          "sports_store_photo": [],
          "sports_store_sports_gear": [],
          "store_name": null,
          "updated_user_id": null
        }
        this.selectSportsGearValues = []
        this.linkList = []
        this.uploadFileList = []
        this.saveflag = false
      },
      cangePostalCode(event) {
        axios.get(`https://api.zipaddress.net/?zipcode=${event.target.value}`).then(rs => {
          const response = rs.data
          if (response.data) {
            this.sport_store.address_prefecture = response.data.pref
            this.sport_store.address_city_town_village = response.data.city
            this.sport_store.address_street_number = response.data.town
          }
      })
      },
      // 編集内容を保存
      async saveChanges() {
        this.saveflag = false
        // 入力チェック
        const validResult = await this.$refs.store_form.validate()
        if (!validResult.valid) {
          return;
        }
        // 写真リスト
        var sports_store_photo = []
        this.uploadFileList.forEach( file => {
          var sports_photo = {
            record_id: file.record_id,
            filename: file.name,
            path: file.url,
          }
          sports_store_photo.push(sports_photo)
        })
        this.sport_store.sports_store_photo = sports_store_photo
        // 競技リスト
        var sports_store_sports_gear = []
        this.selectSportsGearValues.forEach( gear => {
          var sports_gear = {
            sports_store_id: this.sportsStoreId,
            sport_id: gear,
          }
          sports_store_sports_gear.push(sports_gear)
        })
        this.sport_store.sports_store_sports_gear = sports_store_sports_gear
        // リンクマスタ
        var sports_store_link = []
        this.linkList.forEach(link => {
          var store_link = {
            sports_store_id: this.sportsStoreId,
            category: link.category,
            path: link.path,
          }
          sports_store_link.push(store_link)
        })
        this.sport_store.sports_store_link = sports_store_link
        console.log(this.sport_store)

        var url
        if (this.sport_store.sports_store_id) {
          url = process.env.VUE_APP_API_URL + '/sportsstore/update/' + this.sport_store.sports_store_id
        } else {
          url = process.env.VUE_APP_API_URL + '/sportsstore/add'
        }

        axios({
          method: "POST",
          url: url,
          data: JSON.stringify(this.sport_store), 
          headers:{'Content-Type': 'application/json; charset=utf-8'}
        })
        .then(response => {
          console.log(response.data); // mockData
          console.log(response.status); // 200
          this.getData(response.data.sports_store_id)
          this.saveflag = true;
        })
      },
      // 写真を追加＆プレビュー
      inputImageFile(event) {
        if(this.uploadFileImage != null){
          var reader = new FileReader();
          reader.onload = () => {
            const fileData = {
                record_id: null,
                name: event.target.files[0].name,
                url: reader.result
              }
            this.uploadFileList.push(fileData)
            this.uploadFileImage = null
          }
          reader.readAsDataURL(event.target.files[0]);
        }
      },
      // 写真リスト削除
      deleteImage(index) {
        this.uploadFileList.splice(index,1);
      },
      // リンクリスト削除
      deleteLink(index) {
        this.linkList.splice(index,1);
      },
      // 追加
      linkAddRow() {
        this.linkList.push({
          category: null, path: null
        });
      },
      required(v) {
        return !!v || 'Field is required'
      },
    },
  }
</script>